import {
  startLoading
} from '@/plugins/loading'
import http from '@/plugins/api'
import * as types from './types'

function isLogoFormatValid(logo) {
  // Check if selected images has valid extensions
  for (let i = 0; i < logo.length; i++) {
    var ext = logo[i].name.match(/\.([^.]+)$/)[1]

    // Return false if extension is invalid
    if (ext.match(/(jpg|jpeg|png)/) === null) {
      return false
    }
  }
  return true
}

export default {
  /**
   * Reset location values to its defaults
   */
  resetLocationValues({
    commit
  }) {
    commit(types.RESET_LOCATION)
  },
  /**
   * Get states
   * @param {Number} locationID - Location ID
   */
  async getStates({
    commit,
    dispatch
  }) {
    const r = await startLoading(dispatch, 'getStates', () =>
      http.get('location/getstates')
    )
    commit(types.SET_STATES, r.data)
    return r.data
  },
  /**
   * Get location by id
   * @param {Number} locationID - Location ID
   */
  async getLocation({
    dispatch
  }, locationID) {
    const r = await startLoading(dispatch, 'getLocation', () =>
      http.get(`location/get?id=${locationID}`)
    )
    return r.data
  },
  /**
   * Get all locations by based on user
   * @param {Object} params - SearchOptions object
   */
  async getLocationsByUser({
    rootState,
    commit,
    dispatch
  }, params = {}) {
    // Remove object reactivity
    params = JSON.parse(JSON.stringify(params))

    // Set market segments by default (used on Upsert User) or assigned the ones selected in the search area (used on Location List)
    if (typeof params.marketSegments !== 'undefined') {
      params.marketSegments = `[${params.marketSegments.join()}]`
    } else {
      params.marketSegments = `[${rootState.video.marketSegments.map(item => item.id).join()}]`
    }

    // Call API
    const r = await startLoading(dispatch, 'getLocationsByUser', () =>
      http.get('location/getbyuser', {
        params
      })
    )
    // Set locations
    commit(types.SET_LOCATIONS, r.data.items)

    return r.data.count
  },
  /**
   * Create new location
   */
  async createLocation({
    commit,
    dispatch
  }, location) {
    // Prepare FormData
    let formData = new FormData()
    formData.append('name', location.name)
    formData.append('accountNumber', location.accountNumber)
    formData.append('stateID', location.stateID)
    formData.append('marketSegments', location.marketSegments)

    // Append photos to FormData
    if (location.logo !== null && location.logo.length > 0) {
      if (isLogoFormatValid(location.logo)) {
        if (location.logo[0].size > 150000) {
          throw new Error('File is too big. (Limit 150kb)')
        }
        for (let i = 0; i < location.logo.length; i++) {
          formData.append('logo', location.logo[i])
        }
      } else {
        location.logo = []
        throw new Error(`The selected file has an invalid extension. Please make sure you select a file with extension JPG, JPEG or PNG.`)
      }
    }

    // Call API
    const r = await startLoading(dispatch, 'createLocation', () =>
      http.post('location/create', formData)
    )
    // Note: If there's no data, it means that the location already exists
    if (r.data !== '') {
      commit(types.ADD_LOCATION, r.data)
      return r.data
    } else {
      throw new Error('Location already exists.')
    }
  },
  /**
   * Update existing location
   */
  async updateLocation({
    dispatch
  }, location) {
    // Prepare FormData
    let formData = new FormData()
    formData.append('id', location.id)
    formData.append('name', location.name)
    formData.append('accountNumber', location.accountNumber)
    formData.append('marketSegments', location.marketSegments)
    formData.append('stateID', location.stateID)
    formData.append('updateLogo', (location.logo === null && location.logoBase64 !== null) ? 0 : 1)

    // Append photos to FormData
    if (location.logo !== null && location.logo.length > 0) {
      if (isLogoFormatValid(location.logo)) {
        if (location.logo[0].size > 150000) {
          throw new Error('File is too big. (Limit 150kb)')
        }
        for (let i = 0; i < location.logo.length; i++) {
          formData.append('logo', location.logo[i])
        }
      } else {
        location.logo = []
        throw new Error(`The selected file has an invalid extension. Please make sure you select a file with extension JPG, JPEG or PNG.`)
      }
    }

    // Call API
    const r = await startLoading(dispatch, 'updateLocation', () =>
      http.post('location/update', formData)
    )
    if (r.data === -1) {
      throw new Error('Location name already exists.')
    } else {
      return r.data
    }
  },
  /**
   * Delete an existing location
   */
  async deleteLocation({
    commit,
    dispatch
  }, location) {
    // Call API
    const r = await startLoading(dispatch, 'deleteLocation', () =>
      http.post('location/delete', {
        id: location.id
      })
    )

    commit(types.DELETE_LOCATION, location)
    return r.data
  },
  /**
   * Get all locations by based on user
   * @param {Object} params - SearchOptions object
   */
  async getReportKPI({
    commit,
    dispatch
  }, locationID) {
    const r = await startLoading(dispatch, 'getReportKPI', () =>
      http.post('location/update', locationID)
    )

    commit(types.SET_KPI_STATS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/location/actions.js